import { createTheme, ThemeProvider } from '@mui/material'
import { colorPalette } from '~/constants/styles/colors'
import { components, MuiTypography } from '~/lib/theme'

const theme = createTheme({
  typography: MuiTypography,
  palette: colorPalette,
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            backgroundColor: '#FADBDA',
          },
        },
      },
    },
    ...components,
  },
})

export const CampaignCreateThemeProvider = (props: { children: React.ReactNode }) => (
  <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
)
